export default IconBluetoothX => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-bluetooth-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7 8l10 8l-5 4v-16l1 .802m0 6.396l-6 4.802" />
  <path d="M16 6l4 4" />
  <path d="M20 6l-4 4" />
</svg>`;